/** util funcs for titles/headlines */
export const formatHeadline = (headline: string) => {
  const formattedHeadline = headline.replace(
    /([.?!])\s*(?=[A-Z])/g,
    "$1<br />"
  );
  return { __html: formattedHeadline };
};
